import React from 'react';
import { Outlet } from 'react-router-dom';
import QoreConnectShell from './QoreConnectShell';

/** Layout route: shell chrome + nested community pages */
const QoreConnectLayout = () => (
  <QoreConnectShell mainClass="qc-main--wide">
    <Outlet />
  </QoreConnectShell>
);

export default QoreConnectLayout;